// Why the middlegame went wrong (Tactic, Missed chance, Time, Positional), for
// games whose middlegame result is Blown advantage or Behind. Like `blunder`
// it lives in the scan's facts (`GameFacts.groundCause`), which the filter
// does not read: whoever applies the filter resolves it first into `ids` (the
// game store's `resolveFilter`). Unresolved, it matches no game.
import { oneOf, type FilterCriterion } from '../criterion.ts';
import { GROUND_CAUSES, type GroundCause } from '@chess/api-model';

const LABEL: Record<GroundCause, string> = {
  tactic: 'Tactic',
  missed: 'Missed chance',
  time: 'Time',
  positional: 'Positional',
};

export const groundCause: FilterCriterion<'groundCause'> = {
  key: 'groundCause',
  query: 'ground-cause',
  many: true,
  parse: oneOf(GROUND_CAUSES),
  format: (v) => v,
  matches: (_game, _v, filter) => !!filter.ids,
  control: {
    kind: 'choice',
    order: 68,
    more: true,
    label: 'Lost ground by',
    options: GROUND_CAUSES.map((c) => [c, LABEL[c]] as [GroundCause, string]),
  },
};
